/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";

import Loading from "../../../components/Loading";
import PlantQuotasTabComponent from "../../../components/ScheduleConfig/PlantQuotasTabComponent";

import useStyles from "./styles";
import { getDataStorage } from "../../../utils/filterManagementDataStore";

const PlantQuota = ({
  quotas,
  blocks,
  branches,
  filter,
  setFilter,
  loadQuotas,
  loadTimeBlocks,
  deleteDock,
  subRoutes,
  addQuantity,
  subtractQuantity,
  quotasLoading,
  timeBlocksLoading,
  initialQuotas,
  updatedQuotas,
  quotasDatesIssues,
  schedulingsDatesIssues,
  openConfirmDialog,
  clearQuotasDatesIssues,
  clearSchedulingDatesIssues,
  setQuantity,
  saveConfig,
  getNotificationsFromSchedConfigAsync
}) => {
  const classes = useStyles();

  const plantDate = filter.plantQuotasDate || getDataStorage('plant_quotas_config_selectedTurnDate');
  const branchId = filter.plantQuotasBranch || getDataStorage('plant_quotas_config_checkSingleBranch')?.value;

  const loadValues = async (branchId, plantDate) => {
   loadQuotas({
     idBranch: branchId,
     date: moment(plantDate || new Date()).format('YYYY-MM-DD'),
   });
 }

  const removeItem = (data) => {
    deleteDock(data.id);
  };

  const getNotifications = () => getNotificationsFromSchedConfigAsync();

  const handleSaveConfig = async (values) => {
   const response = await saveConfig(values);
   if(response.success){
      loadValues(branchId, plantDate);
   }
   return response;
  }

  useEffect(() => {

    if (branchId && plantDate) { //Revisar esta condição
      loadValues(branchId, plantDate);
    }

  }, [filter.plantQuotasBranch, filter.plantQuotasDate]);

  

  return (
    <div className={classes.root}>
      {(quotasLoading || timeBlocksLoading) && <Loading />}
      <PlantQuotasTabComponent
        subRoutes={subRoutes}
        quotas={quotas}
        addQuantity={addQuantity}
        subtractQuantity={subtractQuantity}
        setQuantity={setQuantity}
        saveConfig={handleSaveConfig}
        updatedQuotas={updatedQuotas}
        initialQuotas = {initialQuotas}
        onDeleteItem={removeItem}
        branches={branches}
        turns={blocks}
        filter={filter}
        setFilter={setFilter}
        quotasDatesIssues = {quotasDatesIssues}
        clearQuotasDatesIssues = {clearQuotasDatesIssues}
        schedulingsDatesIssues = {schedulingsDatesIssues}
        clearSchedulingDatesIssues = {clearSchedulingDatesIssues}
        openConfirmDialog= {openConfirmDialog}
        getNotificationsFromSchedConfigAsync={getNotifications}
      />
    </div>
  );
};

const mapState = (
  {
    plantQuotas: { quotas, loading, updatedQuotas, initialQuotas, warning, error},
    timeBlocks: { blocks },
    timeBlocks,
    notifications
  }) => ({
  quotas,
  initialQuotas,
  updatedQuotas,
  quotasDatesIssues: warning,
  schedulingsDatesIssues: error,
  blocks,
  quotasLoading: loading,
  timeBlocksLoading: timeBlocks.loading,
  notifications: notifications.allNotifications
});
const mapDispatch = (dispatch) => ({
  loadTimeBlocks: (payload) => dispatch.timeBlocks.loadAsync(payload),
  loadQuotas: (payload) => dispatch.plantQuotas.loadAsync(payload),
  openConfirmDialog: (payload) =>
  dispatch?.dialogs?.setConfirmDialogAsync(payload),
  saveConfig: (payload) => dispatch.plantQuotas.saveConfigAsync(payload),
  deleteDock: (id) => dispatch.plantQuotas.deleteAsync(id),
  addQuantity: (item) => dispatch.plantQuotas.addQuantity(item),
  subtractQuantity: (item) => dispatch.plantQuotas.subtractQuantity(item),
  setQuantity: (payload) => dispatch.plantQuotas.setQuantityAsync(payload),
  clearQuotasDatesIssues: (payload) => dispatch.plantQuotas.clearWarning(payload),
  clearSchedulingDatesIssues: (payload) => dispatch.plantQuotas.clearError(payload),
  getNotificationsFromSchedConfigAsync: () => dispatch.notifications.getNotificationsFromSchedConfigAsync()
});

PlantQuota.propTypes = {
  quotas: PropTypes.array.isRequired,
  blocks: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  loadQuotas: PropTypes.func.isRequired,
  deleteDock: PropTypes.func.isRequired,
  subRoutes: PropTypes.array.isRequired,
  addQuantity: PropTypes.func.isRequired,
  subtractQuantity: PropTypes.func.isRequired,
  loadTimeBlocks: PropTypes.func.isRequired,
  quotasLoading: PropTypes.bool,
  timeBlocksLoading: PropTypes.bool.isRequired,
  saveConfig: PropTypes.func.isRequired,
  getNotificationsFromSchedConfigAsync: PropTypes.func.isRequired
};

export default connect(mapState, mapDispatch)(PlantQuota);
